module.exports = "/layout/app/images/bg-section-select-your-theme-after.8ad708d9.svg";